// extracted by mini-css-extract-plugin
export var divider = "_id-7";
export var itemsToggle = "_id-8";
export var mergeModal = "_id-1";
export var optionCard = "_id-4";
export var radioGroup = "_id-6";
export var radioOption = "_id-0";
export var selected = "_id-5";
export var shipmentOptions = "_id-2";
export var tableOptions = "_id-3";